import { withRouter } from "react-router";
import { BlockStack, Button, Card, Page, SkeletonBodyText, Text } from "@shopify/polaris";
import "./index.scss";
import Langauge from "../../../i18n/Language";
import { reqGetOnPageStatistics } from "../../../api/index";
import { useEffect, useState } from "react";

const t = Langauge;
let calculateTimerArr = [];
const SEOMetadata = (props) => {
    const {
        history
    } = props;

    const [altTextNum, setAltTextNum] = useState(0);
    const [metaTagNum, setMetaTagNum] = useState(0);
    const [isShowCalculateData, setIsShowCalculateData] = useState(false);

    const handleSettingClick = (type) => {
        if (type === 'altText') {
            history.push('/on-page-seo/image-alt-text');
        } else if (type === 'metaTag') {
            history.push('/on-page-seo/bulk-edit/manual-bulk-edit');
        }
    };

    const finishTip = (type = 'alt') => {
        return <div className="seo_metadata_finish_tip flex_layout">
            <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99963 2.40039C11.0924 2.40039 13.6002 4.90721 13.6002 8C13.6002 11.0928 11.0924 13.5996 7.99963 13.5996C4.90701 13.5994 2.40002 11.0927 2.40002 8C2.40002 4.90733 4.90701 2.40059 7.99963 2.40039ZM10.3717 6.38281C10.2013 6.2125 9.92588 6.21248 9.75549 6.38281L7.44592 8.69238L6.44495 7.69141C6.27455 7.52109 5.99815 7.52109 5.82776 7.69141C5.65737 7.86179 5.65742 8.13818 5.82776 8.30859L7.13733 9.61816C7.30763 9.78803 7.58323 9.78802 7.75354 9.61816L10.3717 7C10.5421 6.82959 10.5421 6.55322 10.3717 6.38281Z" fill="#29845A" />
            </svg>
            <Text as="p" color="subdued">
                {type === 'alt' ? t("All images have alt text.") : t("All pages have meta tag.")}
            </Text>
        </div>
    }

    // 获取meta优化记录
    const getMetadataData = async () => {
        const res = await reqGetOnPageStatistics();
        if (res.ack === 1) {
            let _t = res.data;
            if (_t.is_calculating === 1) {
                // 需要轮询数据
                if (calculateTimerArr.length === 0) {
                    let timer = setInterval(() => {
                        getMetadataData();
                    }, 3000)
                    calculateTimerArr.push(timer);
                }
            } else {
                clearCalculateTimerArr();
            }
            setIsShowCalculateData(_t.is_calculating === 0 || _t.pages_audited > 0);
            let _alt = _t.pages_missing_alt_text;
            setAltTextNum(_alt.total - _alt.has);
            let _meta = _t.pages_missing_meta_tags;
            setMetaTagNum(_meta.total - _meta.has);
        }
    }

    // 清除轮询数据定时器
    const clearCalculateTimerArr = () => {
        calculateTimerArr.map(timer => {
            clearInterval(timer);
            calculateTimerArr.pop();
            return false;
        })
    }

    useEffect(() => {
        getMetadataData();

        return () => {
            clearCalculateTimerArr();
        }
    }, []);

    return (
        <div className="ai_blog_generator_pages">
            <Page>
                <title>SEOWILL - SEO Metadata</title>

                <Card padding={0}>
                    <div className="seo_metadata_container">
                        {/* Auto-Generated Images Alt Text Card */}
                        <div className="seo_metadata_card alt_text_card">
                            <div className="seo_metadata_image_wrapper">
                                <img
                                    src="/imgs/indoorImg/new/ImageAltText.png"
                                    alt=""
                                    className="seo_metadata_preview_image"
                                />
                            </div>
                            <div className="seo_metadata_card_info">
                                <BlockStack>
                                    <div className="seo_metadata_card_header">
                                        <Text variant="headingMd" as="h2" fontWeight="semibold">
                                            {t("Auto-Generated Images Alt Text")}
                                        </Text>
                                    </div>
                                    {
                                        !isShowCalculateData ? <div className="meta_loading"><SkeletonBodyText lines={1} /></div> :
                                            altTextNum > 0 ? <Text as="p" color="subdued">
                                                <span style={{ color: "#005BD3" }}>{altTextNum}</span> {t("images missing alt text.")}
                                            </Text> : finishTip('alt')
                                    }
                                </BlockStack>
                                <div className="seo_metadata_card_actions">
                                    <Button
                                        onClick={() => handleSettingClick('altText')}
                                    >
                                        {t("Setting")}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Auto-Generated Meta Tag Card */}
                        <div className="seo_metadata_card meta_tag_card">
                            <div className="seo_metadata_image_wrapper">
                                <img
                                    src="/imgs/indoorImg/new/MetaTag.png"
                                    alt="Meta Tag Preview"
                                    className="seo_metadata_preview_image"
                                />
                            </div>
                            <div className="seo_metadata_card_info">
                                <BlockStack>
                                    <div className="seo_metadata_card_header">
                                        <Text variant="headingMd" as="h2" fontWeight="semibold">
                                            {t("Auto-Generated Meta Tag")}
                                        </Text>
                                    </div>
                                    {
                                        !isShowCalculateData ? <div className="meta_loading"><SkeletonBodyText lines={1} /></div> :
                                            metaTagNum > 0 ? <Text as="p" color="subdued">
                                                <span style={{ color: "#005BD3" }}>{metaTagNum}</span> {t("pages missing meta tag.")}
                                            </Text> : finishTip('meta')
                                    }
                                </BlockStack>
                                <div className="seo_metadata_card_actions">
                                    <Button
                                        onClick={() => handleSettingClick('metaTag')}
                                    >
                                        {t("Setting")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Page>
        </div>
    );
};

export default withRouter(SEOMetadata);